<template>
  <div id="app">
    <GPHeader />
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '../node_modules/fullpage.js/dist/fullpage.css';
@import 'scss/_normalize.scss';
@import 'scss/_global.scss';

@font-face {
  font-family: 'Avenir-Black';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/AvenirLTStd-Black.otf') format('otf');
  src: url('./assets/fonts/AvenirLTStd-Black.woff') format('woff');
}

@font-face {
  font-family: 'Avenir-Light';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/AvenirLTStd-Light.otf') format('otf');
  src: url('./assets/fonts/AvenirLTStd-Light.woff') format('woff');
}

@font-face {
  font-family: 'Pingfang-Regular';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/PingFang-HK-Regular-2.otf') format('otf');
  src: url('./assets/fonts/PingFang-HK-Regular-2.woff') format('woff');
}

@font-face {
  font-family: 'Pingfang-Semibold';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/PingFang-HK-Semibold-2.otf') format('otf');
  src: url('./assets/fonts/PingFang-HK-Semibold-2.woff') format('woff');
}

@font-face {
  font-family: 'Pingfang-Bold';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/PingFang-Bold.otf') format('otf');
  src: url('./assets/fonts/PingFang-Bold.woff') format('woff');
}

#app {
  font-family: 'Pingfang-Regular', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-image: url(./assets/mesh.png);
  background-attachment: fixed;
  background-size: auto;
  background-repeat: repeat;
  user-select: none;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.25s ease;
}

.fade-leave-active {
  transition: opacity 0.25s ease;
  opacity: 0;
}
@media (max-width: 1024px) {
  #app {
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue